<template>
  <div class="course-item-wrapper">
    <div v-if="courseList.length && !loading" class="list-content">
      <div class="list-item mt-2" v-for="item in courseList" :key="item.id">
        <div class="d-flex justify-center" style="height: 100%;">
          <div class="d-flex">
            <div class="img">
              <img class="mr-1" style="width: 180px; height: 137px; border-radius: 4px" :src="item.cover" alt="" />
            </div>
          </div>
          <div style="flex: 1; height: 100%;display: flex;
    flex-direction: column;
    justify-content: space-between;">
            <div class="d-flex mt-3">
              <span class="course-badge mr-1" :style="'background-color:' + classType[1].color">{{
                classType[1].label
              }}</span>
              <a-tooltip placement="topLeft">
                <template #title>
                  <span>{{ item.className || item.name }}</span>
                </template>
                <div class="font-16 font-bold text-cut title active">{{ item.className || item.name }}</div>
              </a-tooltip>
              <!-- <span
                v-if="type === 'onTime' && item.lastStudy && (item.classesProp === '1' || item.classesProp === '0')"
                class="course-badge nearly ml-1"
              >最近在学</span
              > -->
            </div>
            <div class="d-flex justify-between mt-3 font-12" v-if="item.lastSchedule && item.lastSchedule.id && (item.classesProp === '1' || item.classesProp === '0')">
              <div class="d-flex" style="color: #84878d">
                <div>学习至：</div>
                <div v-if="item.lastSchedule && item.lastSchedule.id" class="learn-to text-cut">
                  {{ item.lastSchedule.scheduleName }}
                </div>
                <div v-else>暂无记录</div>
              </div>
            </div>
            <div class="d-flex justify-between mt-3 font-12" v-if="item.lastSchedule && item.lastSchedule.id && type === 'expire'">
              <div class="d-flex" style="color: #84878d">
                <div>学习至：</div>
                <div v-if="item.lastSchedule && item.lastSchedule.id" class="learn-to text-cut">
                  {{ item.lastSchedule.scheduleName }}
                </div>
                <div v-else>暂无记录</div>
              </div>
            </div>
            <div
              class="d-flex progress mt-3 font-12"
              v-if="showCourseProgress && (item.classesProp === '1' || item.classesProp === '0')"
            >
              <div class="mr-2 live_text">已学 {{ item.progress ? item.progress : 0 }}%</div>
              <a-progress class="flex-1" :percent="item.progress || 0" status="active" :showInfo="false" />
            </div>
            <div class="d-flex progress mt-3 font-12" v-if="showCourseProgress && type === 'expire'">
              <div class="mr-2 live_text">已学 {{ item.progress ? item.progress : 0 }}%</div>
              <a-progress class="flex-1" :percent="item.progress || 0" status="active" :showInfo="false" />
            </div>
            <div class="d-flex justify-between font-12">
              <div class="d-flex" v-if="item.classesProp === '1' || item.classesProp === '0'">
                <div @click.stop="toLiveCalendar(item)" v-if="type === 'onTime' && (item.classesProp === '1' || item.classesProp === '0')" class="d-flex mr-2 live-list-btn">
                  <img class="icon-img mr-1" :src="kebiao" alt="" />
                  <span class="live_text">直播课表</span>
                </div>
                <div class="d-flex mr-2" v-if="item.homeworkNum > 0">
                  <img class="icon-img mr-1" :src="zuoye" alt="" />
                  <div class="live_text mr-num">作业</div>
                  <div>{{ item.homeworkNum }}</div>
                </div>
                <div class="d-flex mr-2" v-if="item.classesType === '1'">
                  <img class="icon-img mr-1" :src="wenda" alt="" />
                  <div class="live_text mr-num">答疑</div>
                  <div>{{ item.questionNum }}</div>
                </div>
                <div class="d-flex mr-2">
                  <img class="icon-img mr-1" :src="ziliao" alt="" />
                  <div class="live_text mr-num">资料</div>
                  <div>{{ item.resourceNum }}</div>
                </div>
              </div>
              <div v-else class="d-flex">
                <div class="d-flex mr-2" v-if="item.examNum > 0">
                  <img class="icon-img mr-1" :src="zuoye" alt="" />
                  <div class="live_text mr-num">作业</div>
                  <div>{{ item.examNum }}</div>
                </div>
                <div class="d-flex mr-2" v-if="item.qaNum">
                  <img class="icon-img mr-1" :src="wenda" alt="" />
                  <div class="live_text mr-num">答疑</div>
                  <div>{{ item.qaNum }}</div>
                </div>
                <div class="d-flex mr-2" v-if="item.resourceNum">
                  <img class="icon-img mr-1" :src="ziliao" alt="" />
                  <div class="live_text mr-num">资料</div>
                  <div>{{ item.resourceNum }}</div>
                </div>
              </div>
              <div v-if="type === 'onTime'">
                <div class="d-flex" v-if="type === 'onTime' && item.liveScheduleList && item.liveScheduleList.length > 0">
                  <!-- <div>直播课次：</div> -->
                  <!-- <div
                    v-if="item.liveScheduleList && item.liveScheduleList.length > 0"
                    class="text-cut-1 living-course"
                  >
                    {{ item.liveScheduleList[0].scheduleName }}
                  </div> -->
                  <!-- <div v-else>暂无正在直播课次</div> -->
                </div>
                <!-- <a-button
                  v-if="!item.lastSchedule || !item.lastSchedule.id"

                  type="primary"
                  @click.stop="goToClassDetail(item, '1')"
                >
                  开始学习
                </a-button> -->
              </div>
              <div v-else>
                <!-- disabled -->
                <a-button class="overdue-course mr-3 mb-3" @click="expired"> 已过期 </a-button>
              </div>
              <div class="d-flex" style="position: relative" v-if="type === 'onTime'">
                <a-button style="position: absolute; top: -48px;" class="mr-3 mb-3 live living" type="primary" v-if="type === 'onTime' && item.liveScheduleList && item.liveScheduleList.length > 0" @click.stop="toLivePlay(item)">
                  <div class="d-flex">
                    直播中
                    <img class="living-icon ml-1" :src="livingIcon" alt="" />
                  </div>
                </a-button>
                <!-- <a-button
                  v-if="!item.lastWatchTime && type === 'onTime'&&(item.classesProp === '1' || item.classesProp === '0')"
                  class="mr-3 mb-3"
                  type="primary"
                  @click.stop="goToClassDetail(item, '1')"
                >
                  开始学习1
                </a-button> -->
                <div class="no_live mr-3 mb-3" @click="livePlayer(item)" @click.stop="goToClassDetail(item, '1')" v-if="
                  !item.lastWatchTime && type === 'onTime' && (item.classesProp === '1' || item.classesProp === '0')
                ">
                  {{ !item.lastStudy ? '开始学习' : '继续学习' }}
                </div>
                <!-- <custom-button :item="item"></custom-button> -->
                <!-- <a-button
                  v-if="item.classesProp !== '1' && item.classesProp !== '0'"
                  type="primary"
                  class="mr-3 mb-3"
                  @click.stop="goToClassMock(item)"
                >
                  开始学习
                </a-button> -->
                <div class="no_live mr-3 mb-3" v-if="item.classesProp !== '1' && item.classesProp !== '0'" @click.stop="goToClassMock(item)">
                  {{ !item.lastStudy ? '开始学习' : '继续学习' }}
                </div>
                <!-- <a-button
                  v-if="item.lastWatchTime"
                  class="mr-3 mb-3"
                  type="primary"
                  @click.stop="goToClassDetail(item, '1')"
                >
                  继续学习
                </a-button> -->
                <div v-if="item.lastWatchTime" class="mr-3 mb-3 no_live" type="primary" @click.stop="goToClassDetail(item, '1')">
                  {{ !item.lastStudy ? '开始学习' : '继续学习' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex pt-7 pb-4" style="justify-content: space-between;">
        <div style="font-size: 14px;color: rgba(0,0,0,0.6);">共{{ total }}条课程</div>
        <a-pagination v-model="current" :total="total" show-less-items @change="pageChange" />
      </div>
    </div>
    <div v-else-if="courseList.length === 0 && !loading" class="empty-content">
      <div class="d-flex justify-center mt-10">
        <img class="empty-img" :src="empty" alt="" />
      </div>
      <div class="text-center mt-4" v-if="type == 'expire'">暂无过期课程~</div>
      <div class="text-center mt-4" v-else>暂无课程~</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ziliao from '@/assets/icons/ziliao.png'
import decorate from '@/assets/icons/装饰@3x.png'
import kebiao from '@/assets/icons/zhibo.png'
import zuoye from '@/assets/icons/zuoye2.png'
import wenda from '@/assets/icons/wenda1.png'
import empty from '@/assets/course_empty.png'
import avatar from '@/assets/avatar.png'
import livingIcon from '@/assets/icons/living.gif'
import { goToLivePlayer } from '@/utils/livePlay'
import { mapState } from 'vuex'
// import customButton from '@/components/button'
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'onTime',
    },
    loading: {
      type: Boolean,
      default: true,
    },
    showCourseProgress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      url: 'https://static.51lss.com/data',
      ziliao,
      decorate,
      avatar,
      empty,
      kebiao,
      zuoye,
      wenda,
      livingIcon,
      current: 1,
      total: 0,

      courseTabs: [
        {
          label: '全部',
          value: 1,
        },
        {
          label: '系统班',
          value: 2,
        },
        {
          label: '公开课',
          value: 4,
        },
      ],
      sortTabs: [
        {
          label: '默认',
          value: 1,
        },
        {
          label: '最近学习',
          value: 2,
        },
      ],
      classType: {
        0: {
          label: '公开课',
          color: '#00CBDE',
        },
        1: {
          label: '系统班',
          color: '#FFF5EC',
        },
      },
      courseList: [],
    }
  },
  components: {
    // customButton
  },
  computed: {
    ...mapState({
      planclassesId: (state) => state.course.planclassesId,
    }),
  },
  created() {
    this.total = this.data.length
    this.courseList = this.data
    console.log(this.data)
    this.getListData(this.current)
  },
  mounted() { },
  watch: {
    data() {
      this.total = this.data.length
      this.courseList = this.data
      this.current = 1
      this.getListData(this.current)
    },
  },
  methods: {
    goToClassMock(i) {
      if (i.classesProp === '13') {
        window.open(i.jumpUrl, '_blank')
      } else {
      console.log('111111111', i)
      const type = i.classesType ? i.classesType : i.courseDetailType
      Vue.ls.set('classesType', type)
      const newLink = this.$router.resolve({
        name: 'myAddition',
        query: {
          planclassesId: this.planclassesId,
          classesId: i.id,
          ocode: Vue.ls.get('code')
        },
      })
      window.open(newLink.href, '_blank')
     }
    },
    toLivePlay(item) {
      console.log(item)
      if (item.liveScheduleList && item.liveScheduleList.length) {
        const id = item.liveScheduleList[0].id
        goToLivePlayer(id, this.planclassesId)
      }
    },
    toLiveCalendar(item) {
      console.log('item', item)
      if (this.planclassesId) {
        this.$router.push({ name: 'liveCalendar', query: { planclassesId: this.planclassesId, ocode: Vue.ls.get('code') } })
      } else {
        this.$router.push({ name: 'liveCalendar', query: { planclassesId: null, classesId: item.classesId, ocode: Vue.ls.get('code') } })
      }
    },
    getListData(page) {
      // console.log(this.data)
      if (this.data.length > 0) {
        this.courseList = this.data.slice((page - 1) * 10, page * 10)
        // console.log(this.courseList)
      } else {
        this.courseList = []
      }
    },

    pageChange(page) {
      this.getListData(page)
    },
    async goToClassDetail(i, type) {
      const res = await this.$http.get(
        `/b/classes/biz/studentClasses/v2/detail?classesId=${i.id}&planclassesId=${this.planclassesId}`
      )
      this.$router.push({
        name: 'myClassDetail',
        query: {
          planclassesId: this.planclassesId,
          classesId: i.id,
          type: type,
          ocode: Vue.ls.get('code')
        },
      })
    },
    // goToDetail(item) {
    //   if (this.type === 'onTime') {
    //     console.log(item)
    //     if (item.classesType === 1 || item.classesType === '1') {
    //         this.$router.push({ name: 'gradeDetail', query: { planclassesId: item.planclassesId, planclassesName: item.name } })
    //     } else {
    //         this.$router.push({ name: 'myClassDetail', query: { planclassesId: item.planclassesId, classesId: item.classesId, isSign: true } })
    //     }
    //   }
    // },
    expired() {
      this.$message.warning('课程已过期')
    },
  },
}
</script>

<style scoped lang="less">
.living {
  background: #FC665C !important;
  color: #fff;
  border: 1px solid #FC665C
}
.overdue-course {
  width: 100px;
  height: 40px;
  background: #EAECF1 !important;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #84878D;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #EAECF1
}

.course-item-wrapper {
  min-height: 200px;
}

.list-content {
  .list-item {
    height: 169px;
    &>div {
      // margin-bottom: 10px;
    }

    // padding: 16px 20px;
    color: #5e668d;
    background: #ffffff;
    border-radius: 5px;
  }

  .list-item:hover {
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);

    .active {
      color: #4b7dfd;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .course-badge {
    color: #ff9436;
    border-radius: 3px;
    padding: 0 4px;
    font-size: 12px;
  }

  .live-list-btn {
    cursor: pointser;
  }

  .title {
    max-width: 550px;
    color: #303133;
    font-size: 18px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .learn-to {
    max-width: 500px;
  }

  .living-course {
    max-width: 500px;
  }

  .nearly {
    background-color: #ff1536;
  }

  .progress {
    width: 60%;
    color: #303133;
  }

  .img-wrapper {
    width: 35px;
    height: 35px;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;

    .avatar {
      width: 100%;
    }
  }

  .icon-img {
    width: 15px;
    height: 15px;
  }
}

.empty-img {
  width: 150px;
}

.living-icon {
  width: 10px;
  height: 10px;
}

.expired_btn {
  height: 28px;
  line-height: 28px;
  color: #5e668d;
  background: #f5f8fa;
  border-radius: 14px;
}

.img {
  width: 180px;
  height: 137px;
  margin: 16px;
}

.live_text {
  color: #303133;
}

.font-12 {
  font-size: 12px;
}

.no_live {
  width: 100px;
  height: 40px;
  border-radius: 4px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  background: #4b7dfd;
  cursor: pointer;
  font-size: 14px;
}

.no_live:hover {
  background: #396cef;
}

.live {
  width: 100px;
  height: 40px;
}

.mr-num {
  margin-right: 2px;
}

.mt-2 {
  margin-bottom: 0px;
}
</style>
